<template>
  <div>
    <el-row type="flex" align="middle" justify="space-between">
      <el-col :span="12">
        <a class="page-title" @click="getAssessmentDetail">編輯評估</a>
        <a class="page-title" @click="getQuestions">編輯評估2</a>
      </el-col>
    </el-row>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-form label-position="top" label-width="80px" :model="formLabelAlign">
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item label="年級">
              <el-input disabled v-model="formLabelAlign.gradeName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="語言">
              <el-select disabled v-model="formLabelAlign.lang" placeholder="">
                <el-option
                  v-for="item in languages"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item label="描述">
              <el-input v-model="formLabelAlign.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <vue-dividing-line title="評估題目"></vue-dividing-line>

        <div class="label-text">
          <span>第一部分課題</span>
          <span class="star-mark"> *</span>
        </div>
        <el-row :gutter="30">
          <el-col :span="6"> 課題編號 </el-col>
          <el-col :span="6"> 練習編號 </el-col>
          <el-col :span="6"> 題目編號 </el-col>
        </el-row>
        <draggable
          v-model="topicScopeOne"
          @end="draggableUpdateOne"
          animation="300"
          handle=".mover"
        >
          <el-row
            type="flex"
            align="top"
            v-for="(item, index) in topicScopeOne"
            :key="item.topicId"
            :gutter="30"
          >
            <el-col :span="6">
              <el-form-item label="">
                <el-select disabled v-model="item.topicId" placeholder="">
                  <el-option
                    v-for="item in oneTopic"
                    :key="item.topicId"
                    :label="item.number"
                    :value="item.topicId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-select
                  v-model="item.practiseNumber"
                  value-key="practiseNumber"
                  filterable
                  @focus="getPractisesList(item.topicId, index, 0)"
                  :loading="loading"
                  @change="
                    onSelectChangePractiseNumber(item.practiseNumber, index, 0)
                  "
                  placeholder=""
                >
                  <el-option
                    v-for="item in topicsOneDetail[index]"
                    :key="item.practiseNumber"
                    :label="item.practiseNumber"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-select
                  v-model="item.questionNumber"
                  value-key="questionNumber"
                  :loading="loading"
                  filterable
                  @focus="getPractisesDetail(item.practiseId, index, 0)"
                  @change="
                    onSelectChangeQuestionNumber(item.questionNumber, index, 0)
                  "
                  placeholder=""
                >
                  <el-option
                    v-for="item in practisesOneDetail[index]"
                    :key="item.questionNumber"
                    :label="item.questionNumber"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <i class="el-icon-rank mover"></i>
            </el-col>
          </el-row>
        </draggable>
        <div class="label-text">
          <span>第二部分課題</span>
          <span class="star-mark"> *</span>
        </div>
        <el-row :gutter="30">
          <el-col :span="6"> 課題編號 </el-col>
          <el-col :span="6"> 練習編號 </el-col>
          <el-col :span="6"> 題目編號 </el-col>
        </el-row>
        <draggable
          v-model="topicScopeTwo"
          @update="draggableUpdateTwo"
          animation="300"
          handle=".mover"
        >
          <el-row
            type="flex"
            align="top"
            v-for="(item, index) in topicScopeTwo"
            :key="item.topicId"
            :gutter="30"
          >
            <el-col :span="6">
              <el-form-item label="">
                <el-select disabled v-model="item.topicId" placeholder="">
                  <el-option
                    v-for="item in twoTopic"
                    :key="item.topicId"
                    :label="item.number"
                    :value="item.topicId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <!-- <el-input v-model="item.practiseId"></el-input> -->
                <el-select
                  v-model="item.practiseNumber"
                  :loading="loading"
                  value-key="practiseNumber"
                  filterable
                  @focus="getPractisesList(item.topicId, index, 1)"
                  @change="
                    onSelectChangePractiseNumber(item.practiseNumber, index, 1)
                  "
                  placeholder=""
                >
                  <el-option
                    v-for="item in topicsTwoDetail[index]"
                    :key="item.practiseNumber"
                    :label="item.practiseNumber"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <!-- <el-input v-model="item.questionId"></el-input> -->
                <el-select
                  v-model="item.questionNumber"
                  value-key="questionNumber"
                  :loading="loading"
                  filterable
                  @focus="getPractisesDetail(item.practiseId, index, 1)"
                  @change="
                    onSelectChangeQuestionNumber(item.questionNumber, index, 1)
                  "
                  placeholder=""
                >
                  <el-option
                    v-for="item in practisesTwoDetail[index]"
                    :key="item.questionNumber"
                    :label="item.questionNumber"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <i style="margin-top: 10px;" class="el-icon-rank mover"></i>
            </el-col>
          </el-row>
        </draggable>
        <div class="label-text">
          <span>第三部分課題</span>
          <span class="star-mark"> *</span>
        </div>
        <el-row :gutter="30">
          <el-col :span="6"> 課題編號 </el-col>
          <el-col :span="6"> 練習編號 </el-col>
          <el-col :span="6"> 題目編號 </el-col>
        </el-row>
        <draggable
          v-model="topicScopeThree"
          @update="draggableUpdateThree"
          animation="300"
          handle=".mover"
        >
          <el-row
            type="flex"
            align="top"
            v-for="(item, index) in topicScopeThree"
            :key="item.topicId"
            :gutter="30"
          >
            <el-col :span="6">
              <el-form-item label="">
                <!-- <el-input v-model="item.topicId"></el-input> -->
                <el-select disabled v-model="item.topicId" placeholder="">
                  <el-option
                    v-for="item in threeTopic"
                    :key="item.topicId"
                    :label="item.number"
                    :value="item.topicId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <!-- <el-input v-model="item.practiseId"></el-input> -->
                <el-select
                  v-model="item.practiseNumber"
                  value-key="practiseNumber"
                  filterable
                  :loading="loading"
                  @focus="getPractisesList(item.topicId, index, 2)"
                  @change="
                    onSelectChangePractiseNumber(item.practiseNumber, index, 2)
                  "
                  placeholder=""
                >
                  <el-option
                    v-for="item in topicsThreeDetail[index]"
                    :key="item.practiseNumber"
                    :label="item.practiseNumber"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <!-- <el-input v-model="item.questionId"></el-input> -->
                <el-select
                  v-model="item.questionNumber"
                  value-key="questionNumber"
                  :loading="loading"
                  filterable
                  @focus="getPractisesDetail(item.practiseId, index, 2)"
                  @change="
                    onSelectChangeQuestionNumber(item.questionNumber, index, 2)
                  "
                  placeholder=""
                >
                  <el-option
                    v-for="item in practisesThreeDetail[index]"
                    :key="item.questionId"
                    :label="item.questionNumber"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <i class="el-icon-rank mover"></i>
            </el-col>
          </el-row>
        </draggable>

        <div class="page-button">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="backIndexpage">取消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getQuestions } from "@/api/question";
import { getPractisesDetail,getPractises } from "@/api/practises";
import { getTopics } from "@/api/topics";
import { getAssessmentDetail, putAssessment } from "@/api/assessment";
import draggable from "vuedraggable";
export default {
  components: { draggable },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      topicScopeOne: [],
      topicScopeTwo: [],
      topicScopeThree: [],
      loading: false,
      practisesOneDetail: [],
      practisesTwoDetail: [],
      practisesThreeDetail: [],
      topicsOneDetail: [],
      topicsTwoDetail: [],
      topicsThreeDetail: [],
      practises: [],
      questions: [],
      oneTopic: [],
      twoTopic: [],
      threeTopic: [],
      formLabelAlign: {
        gradeId: null,
        gradeName: null,
        name: null,
        lang: null,
        topicQuestions: [
          {
            topicId: null,
            topicNumber: null,
            topicScope: null,
            practiseId: null,
            practiseNumber: null,
            questionId: null,
            questionNumber: null,
          },
        ],
      },
    };
  },
  created() {
    this.getAssessmentDetail();
    this.getQuestions();
  },
  methods: {
    onSelectChangeQuestionNumber(questionNumber, index, scope) {
      if (scope == 0) {
        this.topicScopeOne[index].questionId = questionNumber.questionId;
        this.topicScopeOne[index].questionNumber =
          questionNumber.questionNumber;
      } else if (scope == 1) {
        this.topicScopeTwo[index].questionId = questionNumber.questionId;
        this.topicScopeTwo[index].questionNumber =
          questionNumber.questionNumber;
      } else if (scope == 2) {
        this.topicScopeThree[index].questionId = questionNumber.questionId;
        this.topicScopeThree[index].questionNumber =
          questionNumber.questionNumber;
      }
    },
    onSubmit() {
      this.putAssessment();
    },
    getQuestions() {
      getQuestions().then((v) => {
        this.questions = v.data;
      });
    },
    backIndexpage() {
      this.$router.push('/evaluate')
    },
    //获取习题
    getPractisesList(a,index, scope){
      // console.log(a)
      let scopeTopics = [];
       this.loading = true;
      let from = {
        lang:this.formLabelAlign.lang,
        _page:0,
        _limit:9999999999999999,
      }
      getPractises(from).then((v)=>{
      this.loading = false;
        scopeTopics = v.data.map((k) => {
            k.practiseId = k.id;
            k.practiseNumber = k.number;
            return k;
          });
          if (scope == 0) {
            this.topicsOneDetail[index] = scopeTopics;
          } else if (scope == 1) {
            this.topicsTwoDetail[index] = scopeTopics;
          } else {
            this.topicsThreeDetail[index] = scopeTopics;
          }
      })
            
    },
    getPractisesDetail(id, index, scope) {
      let scopePractises = [];
      if (id != null) {
        this.loading = true;
        getPractisesDetail(id).then((v) => {
          this.loading = false;
          scopePractises = v.data.questions.map((k) => {
            k.questionId = k.id;
            k.questionNumber = k.number;
            return k;
          });
          if (scope == 0) {
            this.practisesOneDetail[index] = scopePractises;
          } else if (scope == 1) {
            this.practisesTwoDetail[index] = scopePractises;
          } else {
            this.practisesThreeDetail[index] = scopePractises;
          }
        });
      }
    },
    //通过获取习题，获取题目列表
    onSelectChangePractiseNumber(practiseNumber, index, scope) {
      let scopePractises = [];
      if (practiseNumber.id != null) {
        this.loading = true;
        if (scope == 0) {
          this.topicScopeOne[index].practiseId = practiseNumber.id;
          this.topicScopeOne[index].practiseNumber =
            practiseNumber.practiseNumber;
        } else if (scope == 1) {
          this.topicScopeTwo[index].practiseId = practiseNumber.id;
          this.topicScopeTwo[index].practiseNumber =
            practiseNumber.practiseNumber;
        } else if (scope == 2) {
          this.topicScopeThree[index].practiseId = practiseNumber.id;
          this.topicScopeThree[index].practiseNumber =
            practiseNumber.practiseNumber;
        }
        getPractisesDetail(practiseNumber.id).then((v) => {
          this.loading = false;
          scopePractises = v.data.questions.map((k) => {
            k.questionId = k.id;
            k.questionNumber = k.number;
            return k;
          });
          if (scope == 0) {
            this.practisesOneDetail[index] = scopePractises;
          } else if (scope == 1) {
            this.practisesTwoDetail[index] = scopePractises;
          } else {
            this.practisesThreeDetail[index] = scopePractises;
          }
        });
      }
    },
    //获取每个范围的課題
    init() {
      this.getTopics(0).then((k) => {
        this.oneTopic = k.map((v) => {
          v.topicId = v.id;
          return v;
        });
      });
      this.getTopics(1).then((k) => {
        this.twoTopic = k.map((v) => {
          v.topicId = v.id;
          return v;
        });
      });
      this.getTopics(2).then((k) => {
        this.threeTopic = k.map((v) => {
          v.topicId = v.id;
          return v;
        });
      });
    },
    //初始化每个年级每个部分的課題数量
    foundTopicQuestions() {
      if (this.formLabelAlign.gradeId == 1) {
        this.foundArray(0, 11);
        this.foundArray(1, 11);
        this.foundArray(2, 6);
      } else if (this.formLabelAlign.gradeId == 2) {
        this.foundArray(0, 13);
        this.foundArray(1, 10);
        this.foundArray(2, 4);
      } else if (this.formLabelAlign.gradeId == 3) {
        this.foundArray(0, 8);
        this.foundArray(1, 11);
        this.foundArray(2, 8);
      } else if (this.formLabelAlign.gradeId == 4) {
        this.foundArray(0, 10);
        this.foundArray(1, 9);
        this.foundArray(2, 10);
      } else if (this.formLabelAlign.gradeId == 5) {
        this.foundArray(0, 12);
        this.foundArray(1, 10);
        this.foundArray(2, 5);
      } else if (this.formLabelAlign.gradeId == 6) {
        this.foundArray(0, 10);
        this.foundArray(1, 11);
        this.foundArray(2, 8);
      }
    },
    foundArray(topicScope, number) {
      let from = {
        topicId: null,
        topicNumber: null,
        topicScope: topicScope,
        practiseId: null,
        practiseNumber: null,
        questionId: null,
        questionNumber: null,
      };
      for (var i = 0; i < number; i++) {
        this.formLabelAlign.topicQuestions.push(from);
      }
    },
    draggableUpdateOne() {
      this.$forceUpdate();
    },
    draggableUpdateTwo() {
      this.$forceUpdate();
    },
    draggableUpdateThree() {
      this.$forceUpdate();
    },
    getTopics(scope) {
      let from = {
        scope: scope,
        lang: this.formLabelAlign.lang,
        gradeId: this.formLabelAlign.gradeId,
      };
      return getTopics(from).then((v) => {
        return v.data;
      });
    },
    //当前課題分成3个部分
    setFormLabelAlignTopicScope() {
      this.topicScopeOne = this.formLabelAlign.topicQuestions.filter((v) => {
        return v.topicScope == 0;
      });
      this.topicScopeTwo = this.formLabelAlign.topicQuestions.filter((v) => {
        return v.topicScope == 1;
      });
      this.topicScopeThree = this.formLabelAlign.topicQuestions.filter((v) => {
        return v.topicScope == 2;
      });
    },
    putAssessment() {
      let from = {
        name: this.formLabelAlign.name,
        topicQuestions: [
          ...this.topicScopeOne,
          ...this.topicScopeTwo,
          ...this.topicScopeThree,
        ],
      };
      putAssessment(this.id, from).then(() => {
        //消息弹出
         this.$message.success("修改成功");
          this.backIndexpage()
      });
    },
    getAssessmentDetail() {
      getAssessmentDetail(this.id).then((v) => {
        this.formLabelAlign = v.data;
        if (this.formLabelAlign.topicQuestions.length == 0) {
          this.foundTopicQuestions();
        }
        this.init();
        this.setFormLabelAlignTopicScope();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 10px;
  background-color: #fff;
  margin-top: 20px;
}
</style>